<template>
  <div class="p-md-3 w-100">
    <form @submit.prevent="saveUserSettings()">
      <div class="row pb-3 pt-0">
        <div class="col-md-9 d-flex justify-content-start align-items-center mb-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb p-0 m-0">
              <li class="breadcrumb-item"><a href="#">Dashboard</a></li>
              <li class="breadcrumb-item" aria-current="page"> Account Details</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-3">
          <button type="submit" class="btn btn-primary float-end text-dark w-100">
            <i class="fa-duotone fa-solid fa-circle-check me-1"></i> Save Settings
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="d-flex card-header justify-content-start align-items-center">
              <h4 class="header-title">My Account</h4>
            </div>
            <div class="card-body pt-2">
              <div class="mb-2">
                <label class="form-label">First Name</label>
                <input type="text" class="form-control" required v-model="billingFirstName">
              </div>
              <div class="mb-2">
                <label class="form-label">Last Name</label>
                <input type="text" class="form-control" value="Lu-ang" required v-model="billingLastName">
              </div>
              <div class="mb-2">
                <label class="form-label">Legal Business Name</label>
                <input type="text" class="form-control" value="Danilo Motors" required v-model="legalBusinessName">
              </div>
              <div class="mb-2">
                <label class="form-label">Email</label>
                <input type="email" class="form-control opacity-75" disabled required v-model="businessEmail">
              </div>
              <div class="mb-2">
                <label class="form-label">Phone Number</label>
                <input type="text" class="form-control" id="exampleFormControlInput1" required v-model="phoneNumber">
              </div>
              <table class="table">
                <tbody>
                  <tr>
                    <th scope="row" class="d-md-block d-none">User Name:</th>
                    <td scope="row" colspan="2">
                      <p class="fw-bold d-md-none d-block">User Name:</p>
                      {{ businessEmail }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card">
            <div class="d-flex card-header justify-content-start align-items-center">
              <h4 class="header-title">Billing & Shipping Information</h4>
            </div>
            <div class="card-body pt-2">
              <div class="mb-2">
                <label class="form-label">Address 1</label>
                <input type="text" class="form-control" required v-model="billingAddress1">
              </div>
              <div class="mb-2">
                <label class="form-label">City</label>
                <input type="text" class="form-control" required v-model="billingCity">
              </div>
              <div class="mb-2">
                <label class="form-label">State</label>
                <!-- <input type="text" class="form-control" required v-model="billingState"> -->
                <!-- <region-select v-model="billingState" className="form-select" :country="billingCountry" :region="billingState" defaultRegion="'US'"/> -->
              </div>
              <div class="mb-2">
                <label  class="form-label">Postal Code</label>
                <input type="text" class="form-control" required v-model="billingPostCode">
              </div>
              <div class="mb-2">
                <label  class="form-label">Country</label>
                <!-- <input type="text" class="form-control" required v-model="billingCountry"> -->
                <country-select className="form-select" v-model="billingCountry" :country="billingCountry" topCountry="US" />
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4">
          <div class="card">
            <div class="d-flex card-header justify-content-start align-items-center">
              <h4 class="header-title">Shipping Information</h4>
            </div>
            <div class="card-body pt-2">
              <div class="mb-2">
                <label class="form-label">Address 1</label>
                <input type="text" class="form-control" required v-model="shippingAddress1">
              </div>
              <div class="mb-2">
                <label class="form-label">Address 2</label>
                <input type="text" class="form-control" v-model="shippingAddress2">
              </div>
              <div class="mb-2">
                <label class="form-label">City</label>
                <input type="text" class="form-control" required v-model="shippingCity">
              </div>
              <div class="mb-2">
                <label class="form-label">State</label>
                <input type="text" class="form-control" required v-model="shippingState">
              </div>
              <div class="mb-2">
                <label class="form-label">Postal Code</label>
                <input type="text" class="form-control" required v-model="shippingPostCode">
              </div>
              <div class="mb-2">
                <label class="form-label">Country</label>
                <input type="text" class="form-control" required v-model="shippingCountry">
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </form>
  </div>
</template>
    
<script lang="js">
import { defineComponent } from 'vue'
import Mixin from '../mixins/global.mixin'
import { mapState } from 'vuex'
import axios from 'axios';
import appConstants from '@/constants/app.constants';
import Swal from 'sweetalert2'
  
export default defineComponent({
  name: 'AccountDetails',
  mixins: [Mixin],
  computed: mapState([
      'isCollapse',
      'currentSessionEmail',
      'jwtToken',
      'currentSessionRailsID',
      'currentSessionRailsData'
  ]),
  data() {
    return {
      billingFirstName: null,
      billingLastName: null,
      legalBusinessName: null,
      businessEmail: null,
      phoneNumber: null,
      billingAddress1: null,
      billingAddress2: null,
      billingCity: null,
      billingCountry: '',
      billingPostCode: null,
      billingState: '',
      businesstaxID: null,
    }
  },
  methods: {
    saveUserSettings: async function () {
      this.toggleFullScreenSpinner(true);
      try {
					const results = await Promise.all([this.updateRailsUserData()]);
					//console.log('Results:', results);
					await this.afterSaveComplete(results);
				} catch (error) {
					console.error('Error running functions:', error);
				}
    },
    updateRailsUserData: async function () {
      let data = {
          "resellers": {
              "business_address": this.billingAddress1,
              "business_name": this.legalBusinessName,
              "business_phone": this.phoneNumber,
              "state": this.billingState,
              "city": this.billingCity,
              "country": this.billingCountry,
              "zip": this.billingPostCode
          }
      };
      return await axios.patch(appConstants.SERVICESURL+'/api/v1/resellers/'+this.currentSessionRailsID, data);
    },
    afterSaveComplete: function (results) {
      this.toggleFullScreenSpinner(false);
      if (results[0]) {
        Swal.fire({
          icon: "success",
          text: "Billing and Shipping information Saved",
          customClass: {
            confirmButton: 'btn-primary'
          }
        });
      }
    },
    getWPShippingAndBilling: function () {
      
          this.billingFirstName = this.currentSessionRailsData.firstname;
          this.billingLastName = this.currentSessionRailsData.lastname;
          this.legalBusinessName = this.currentSessionRailsData.business_name;
          this.billingAddress1 = this.currentSessionRailsData.business_address;
          this.billingAddress2 = null;
          this.billingCity = this.currentSessionRailsData.city;
          this.billingPostCode = this.currentSessionRailsData.zip;
          this.billingCountry = this.currentSessionRailsData.country;
          this.billingState = this.currentSessionRailsData.state;
          this.phoneNumber = this.currentSessionRailsData.business_phone;
        
    },
  },
  mounted() {
    setTimeout( () => {
      this.toggleFullScreenSpinner(false);
    }, 500);
    this.businessEmail = this.currentSessionEmail;
    this.getWPShippingAndBilling();
  }
});
</script>
    